<template>
  <DatatableReportV3
    title="Sales Tax"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import { customerClassificationColumns } from "@/lib/customerTypes";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        order: [[0, "desc"]],
        columns: [
          {
            data: "completed_on",
            title: "Completed",
            filterName: "finalized_at",
            searchable: false,
            responsivePriority: 5
          },
          { data: "invoice", responsivePriority: 2 },
          ...customerClassificationColumns(),
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 10 },
          { data: "customer_phone", title: "Phone", responsivePriority: 6 },
          { data: "job", responsivePriority: 7 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 11
          },
          { data: "address", orderable: false, responsivePriority: 12 },
          {
            data: "tax_zone_name",
            title: "Tax Zone Name",
            searchable: false,
            responsivePriority: 8
          },
          {
            data: "tax_rate",
            title: "Tax Rate",
            searchable: false,
            responsivePriority: 9
          },
          {
            data: "sales_tax",
            title: "Sales Tax",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.sales_tax,
            searchable: false,
            responsivePriority: 3
          },
          {
            data: "invoice_total",
            title: "Invoice Total",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.invoice_total,
            searchable: false,
            responsivePriority: 4
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Sales Tax" });
  }
};
</script>

<style lang="scss" scoped></style>
